import gql from 'graphql-tag';

const CREATE_CONTRACT_TEMPLATE = gql`
  mutation($template: ClientContractTemplateInput!) {
    createContractTemplate(template: $template) {
      templateId
      name
      description
      items {
        itemId
        # subscriptionType
        frequency {
          unit
          type
          quantity
          recurringMode
          recurringBefore
        }
        unitPrice
        unitType
        quantity
        # effectiveDate
        serviceItem {
          itemId
          name
        }
      }
      customItems {
        serviceItem {
          itemId
          name
        }
        unitPrice
      }
      conditionalPricing {
        pricingId
        name
        description
        ruleCondition
        items {
          itemId
          serviceItem {
            itemId
            name
          }
          businessHoursPrice
          afterHoursPrice
        }
      }
      blacklistedItems {
        itemId
        name
      }
      sla {
        id
        sla {
          id
          name
        }
        slaOrder
      }
    }
  }
`;

const UPDATE_CONTRACT_TEMPLATE = gql`
  mutation($templateId: ID!, $template: ClientContractTemplateInput!) {
    updateContractTemplate(templateId: $templateId, template: $template) {
      templateId
      name
      description
      items {
        itemId
        # subscriptionType
        frequency {
          unit
          type
          quantity
          recurringMode
          recurringBefore
        }
        unitPrice
        unitType
        quantity
        effectiveDate
        endDate
        carryForwardRemainingBlockHours
        autoRenew
        serviceItem {
          itemId
          name
        }
      }
      customItems {
        serviceItem {
          itemId
          name
        }
        unitPrice
      }
      conditionalPricing {
        pricingId
        name
        description
        ruleCondition
        items {
          itemId
          serviceItem {
            itemId
            name
          }
          businessHoursPrice
          afterHoursPrice
        }
      }
      blacklistedItems {
        itemId
        name
      }
      sla {
        id
        sla {
          id
          name
        }
        slaOrder
      }
    }
  }
`;

const DELETE_CONTRACT_TEMPLATE = gql`
  mutation($templateId: ID!) {
    deleteContractTemplate(templateId: $templateId)
  }
`;

const CREATE_CLIENT_CONTRACT = gql`
  mutation($contract: ClientContractInput!, $clientId: ID!) {
    createClientContract(contract: $contract, clientId: $clientId) {
      contractId
      name
      description
      items {
        itemId
        # subscriptionType
        frequency {
          unit
          type
          quantity
          recurringMode
          recurringBefore
        }
        unitPrice
        unitType
        quantity
        effectiveDate
        endDate
        carryForwardRemainingBlockHours
        autoRenew
        serviceItem {
          itemId
          name
        }
        remindDuration {
          unit
          quantity
        }
      }
      customItems {
        serviceItem {
          itemId
          name
        }
        unitPrice
      }
      conditionalPricing {
        pricingId
        name
        description
        ruleCondition
        items {
          itemId
          serviceItem {
            itemId
            name
          }
          businessHoursPrice
          afterHoursPrice
        }
      }
      blacklistedItems {
        itemId
        name
      }
    }
  }
`;

const UPDATE_CLIENT_CONTRACT = gql`
  mutation(
    $contract: ClientContractInput!
    $contractId: ID!
    $isBillingQueue: Boolean!
  ) {
    updateClientContract(contract: $contract, contractId: $contractId) {
      contractId
      name
      description
      endDate
      items {
        itemId
        # subscriptionType
        frequency {
          unit
          type
          quantity
          recurringMode
          recurringBefore
        }
        unitPrice
        unitType
        quantity
        effectiveDate
        endDate
        carryForwardRemainingBlockHours
        autoRenew
        remindDuration {
          unit
          quantity
        }
        changes @include(if: $isBillingQueue) {
          changeId
          quantity
          quantityChangeOperation
          effectiveDate
          amount
          proRatedAmount
          generateInvoice
        }
        serviceItem {
          itemId
          name
        }
      }
      customItems {
        serviceItem {
          itemId
          name
        }
        unitPrice
      }
      conditionalPricing {
        pricingId
        name
        description
        ruleCondition
        items {
          itemId
          serviceItem {
            itemId
            name
          }
          businessHoursPrice
          afterHoursPrice
        }
      }
      blacklistedItems {
        itemId
        name
      }
      sla {
        id
        slaOrder
        sla {
          id
          name
        }
      }
      pax8LastSyncStatus #OperationStatus
      pax8LastSyncTime
    }
  }
`;

const UPDATE_CONTRACT_SERVICE_ITEM = gql`
  mutation($input: ContractServiceItemInput!) {
    updateContractServiceItem(input: $input) {
      itemId
    }
  }
`;

export {
  CREATE_CONTRACT_TEMPLATE,
  UPDATE_CONTRACT_TEMPLATE,
  DELETE_CONTRACT_TEMPLATE,
  CREATE_CLIENT_CONTRACT,
  UPDATE_CLIENT_CONTRACT,
  UPDATE_CONTRACT_SERVICE_ITEM
};
